import { render, staticRenderFns } from "./SeminarProfile.vue?vue&type=template&id=be48993a&scoped=true&"
import script from "./SeminarProfile.vue?vue&type=script&lang=js&"
export * from "./SeminarProfile.vue?vue&type=script&lang=js&"
import style0 from "./SeminarProfile.vue?vue&type=style&index=0&id=be48993a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be48993a",
  null
  
)

export default component.exports